import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import moment from 'moment-timezone';
import {Container, Typography, Grid, Paper} from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';

import CartoucheVod from 'components/CartoucheVod';
import {axiosInstance} from 'utils/auth.service';

const ITEMS_PER_PAGE = 4;

const Vod = () => {
  const [rentals, setRentals] = useState([]);
  const [page, setPage] = useState(1);

  const {t} = useTranslation();

  useEffect(() => {
    axiosInstance.get('/users/rentals').then(res => setRentals(res.data || []));
  }, []);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const today = moment();
  const vodInProgress = rentals.filter(rental => !rental.end || today.isBefore(rental.end));
  const vodOver = rentals.filter(rental => today.isAfter(rental.end));
  const vodOverSelection = vodOver.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);
  const nbPages = Math.ceil((vodOver.length - 1) / ITEMS_PER_PAGE) || 1;

  return (
    <Paper>
      <Container>
        <div className="spacer" />
        {vodInProgress.length > 0 && (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h4">{t('Locations-en-cours')}</Typography>
            </Grid>
            {vodInProgress.map(vod => (
              <Grid item xs={12} md={6} key={vod.id}>
                <CartoucheVod vod={vod} />
              </Grid>
            ))}
          </Grid>
        )}
        {vodInProgress.length > 0 && vodOverSelection.length > 0 && (
          <Grid item xs={12}>
            <div className="spacer" />
            <div className="spacer" />
          </Grid>
        )}
        {vodOverSelection.length > 0 && (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h4">{t('Locations-terminées')}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Pagination count={nbPages} page={page} onChange={handlePageChange} />
            </Grid>
            <Grid item xs={12} md={6}>
              <p className="page-infos">
                {(page - 1) * ITEMS_PER_PAGE + 1} - {Math.min(vodOver.length, page * ITEMS_PER_PAGE)} de{' '}
                {vodOver.length}
              </p>
            </Grid>
            {vodOverSelection.map(vod => (
              <Grid item xs={12} md={6} key={vod.id}>
                <CartoucheVod vod={vod} />
              </Grid>
            ))}
          </Grid>
        )}
        {rentals.length === 0 && (
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <p>{t('aucune-location')}</p>
            </Grid>
          </Grid>
        )}
      </Container>
    </Paper>
  );
};

export default Vod;
